import "../styles/Timeline.css";
import "../styles/TimelineEnhancements.css";
import * as React from 'react';
import { ApiHelper } from '../ApiHelper';
import { useLoaderData } from "react-router-dom";
import { TimelineContextProvider, useTimeline } from './timeline/TimelineContext';
import { StackPopup } from './timeline/StackPopup';
import { formatNodeName } from '../utils/flamegraphLayout.ts';

type TimelineLoaderData = {
    timeline: any;
};

export function RequestTimeline() {
    const { timeline } = useLoaderData() as TimelineLoaderData;

    return (
        <div>
            <br/>
            <Timeline tableref={convertToDiaghubFormat(timeline)} />
        </div>
            );
}
export async function TimelineLoader() {
    const searchParams = new URLSearchParams(window.location.search);
    const apiUrl = '/api/apitimelines/get?path=' + searchParams.get('path');
    const timeline = await ApiHelper(apiUrl);
    return { timeline };
}

function convertToDiaghubFormat(timeline: any) {
    for (var i = 0; i < timeline.Entries.length; i++) {
        var row = timeline.Entries[i];
        if (row.parsedStack == null) {
            var parsedStack = [];
            for (var j = 0; j < row.Stack.length; j++) {
                var modi = row.Stack[j].ModuleIndex;
                var meti = row.Stack[j].MethodIndex;
                parsedStack.push(
                    {
                        hash: 65000 * modi + meti,
                        module: timeline.Strings[modi],
                        method: timeline.Strings[meti],
                        moduleId: modi,
                    }
                );
            }
            row.parsedStack = parsedStack;
        }
    }

    return {
        stringTable: timeline.Strings,
        datatable: timeline.Entries
    }
}


// below is code from diaghub

var g_timelineData = null;

class Timeline extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.onViewChanged = this.onViewChanged.bind(this);
        this.onWaitHiddenChange = this.onWaitHiddenChange.bind(this);
        this.zoom = this.zoom.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.onThemeChange = this.onThemeChange.bind(this);
        this.onShowMethodFirstChange = this.onShowMethodFirstChange.bind(this);
        var urlParams = new URLSearchParams(window.location.search);
        debugger;
        var defaultView = urlParams.get('viewid');
        if (defaultView == null || defaultView == '') {
            defaultView = 'Timeline';
        }

        // Load theme and showMethodFirst from localStorage
        const savedTheme = localStorage.getItem('timeline-theme') || 'default';
        const savedShowMethodFirst = localStorage.getItem('timeline-showMethodFirst') === 'true';

        this.state = {
            view: defaultView,
            waitsHidden: false,
            hiddenThreads: {},
            microsecondsPerPixel: 20,
            theme: savedTheme,
            showMethodFirst: savedShowMethodFirst
        };
    }

    onViewChanged(e) {
        this.setState({
            view: e.currentTarget.value,
        });
    }

    onWaitHiddenChange(e) {
        this.setState({ waitsHidden: e.target.checked });
    }

    onThemeChange(e) {
        const newTheme = e.target.value;
        this.setState({ theme: newTheme });
        localStorage.setItem('timeline-theme', newTheme);
    }

    onShowMethodFirstChange(e) {
        const newValue = e.target.checked;
        this.setState({ showMethodFirst: newValue });
        localStorage.setItem('timeline-showMethodFirst', newValue.toString());
    }

    zoom(e) {
        var scale = this.state.microsecondsPerPixel;
        if (e.target.id == 'zoomin' || e.target.parentElement.id == 'zoomin') {
            scale = scale / 2;
        } else {
            scale = scale * 2;
        }

        if (scale == 0) scale = 1;
        this.setState({ microsecondsPerPixel: scale })
    }

    componentDidUpdate(previousProps) {

    }

    onVisibilityChange(e) {
        var hiddenThreads = this.state.hiddenThreads;
        hiddenThreads[e.target.value] = !e.target.checked;
        this.setState({ hiddenThreads: hiddenThreads })
    }

    render() {
        var tr = this.props.tableref;

        if (tr.stringTable == null) {
            var nodes = [tr.parent, tr.parent.parent];
            for (var node of nodes) {
                if (tr.stringTable == null) {
                    for (var t of node.dataTables) {
                        if (t.name == 'StringTable') {
                            var stringTable = [];
                            for (var i = 0; i < t.datatable.length; i++) {
                                stringTable[parseInt(t.datatable[i].Index)] = t.datatable[i].String;
                            }
                            tr.stringTable = stringTable;
                            break;
                        }
                    }
                }
            }
        }

        if (tr.stringTable != null) {
            for (var i = 0; i < tr.datatable.length; i++) {
                var row = tr.datatable[i];
                if (row.parsedStack == null) {
                    var parsedStack = [];
                    var spl = row.Stack.split(';');
                    for (var j = 0; j < spl.length; j++) {
                        var pt = spl[j].split(':');
                        var modi = parseInt(pt[0]);
                        var meti = parseInt(pt[1]);
                        parsedStack.push(
                            {
                                hash: 65000 * modi + meti,
                                module: tr.stringTable[modi],
                                method: tr.stringTable[meti],
                                moduleId: modi,
                            }
                        );
                    }
                    row.parsedStack = parsedStack;
                }
            }
        }

        BuildTimeline(this.props.tableref);


        var views = ['Timeline', 'CPU', 'CPUSummary'];
        var viewsButton = views.map(function (result) {
            return (
                <span>
                    <input
                        type="radio"
                        name="viewsel"
                        id="id{result}"
                        value={result}
                        checked={this.state.view === result}
                        onChange={this.onViewChanged}
                    />
                    <label htmlFor="id{result}">{result}</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                </span>
            );
        }, this);

        var threadButtons = this.props.tableref.timelineData.threads.map(function (threadId) {
            return (
                <span>
                    <input type="checkbox" name={'thr' + threadId} id={'thr' + threadId} value={threadId} defaultChecked={!this.state.hiddenThreads[threadId]} data-threadid={threadId} onChange={this.onVisibilityChange} />
                    <label htmlFor={'thr' + threadId}>&nbsp;{threadId}</label>&nbsp;&nbsp;
                </span>);

        }, this);

        return (
            <TimelineContextProvider>
                <div>
                    {/* Sticky control bar - stays visible when scrolling */}
                    <div className="timeline-controls-bar">
                        <div className="timeline-controls-content">
                            <span>View: </span>
                            {viewsButton}
                            <span>Theme: </span>
                            <select value={this.state.theme} onChange={this.onThemeChange}>
                                <option value="default">Default</option>
                                <option value="highcontrast">High Contrast</option>
                                <option value="dark">Dark</option>
                                <option value="colorblind">Colorblind Friendly</option>
                                <option value="print">Grayscale</option>
                            </select>
                            <input
                                type="checkbox"
                                id="hidenamespace"
                                checked={this.state.showMethodFirst}
                                onChange={this.onShowMethodFirstChange}
                            />
                            <label htmlFor="hidenamespace">&nbsp;Hide Namespace</label>
                            <button className="panel-titlebar-button-close" title="Zoom in" onClick={this.zoom} id="zoomin">
                                <i className="fa fa-zoomin"></i>
                            </button>
                            <button className="panel-titlebar-button-close" title="Zoom out" onClick={this.zoom} id="zoomout">
                                <i className="fa fa-zoomout"></i>
                            </button>
                            <span>Threads: </span>
                            {threadButtons}
                            <input type="checkbox" name="hidewaits" id="hidewaits" checked={this.state.waitsHidden} value="hide" onChange={this.onWaitHiddenChange} />
                            <label htmlFor="hidewaits">&nbsp;Hide wait stacks</label>
                        </div>
                    </div>

                    {/* Content area */}
                    <div>
                        {this.state.view == 'Timeline' && <TimelineView tableref={tr} view={this.state.view} hidewaits={this.state.waitsHidden} hiddenthreads={this.state.hiddenThreads} microsecondsPerPixel={this.state.microsecondsPerPixel} theme={this.state.theme} showMethodFirst={this.state.showMethodFirst} />}
                        {this.state.view == 'CPU' && <AggregatedStackView tableref={tr} view={this.state.view} hidewaits={this.state.waitsHidden} hiddenthreads={this.state.hiddenThreads} microsecondsPerPixel={this.state.microsecondsPerPixel} theme={this.state.theme} showMethodFirst={this.state.showMethodFirst} />}
                        {this.state.view == 'CPUSummary' && <CPUSummary tableref={tr} view={this.state.view} hidewaits={this.state.waitsHidden} hiddenthreads={this.state.hiddenThreads} microsecondsPerPixel={this.state.microsecondsPerPixel} theme={this.state.theme} showMethodFirst={this.state.showMethodFirst} />}
                    </div>

                    {/* Add popup component */}
                    <StackPopup timelineData={tr.timelineData} />
                </div>
            </TimelineContextProvider>
        );
    }
}
//class TimelineTable extends React.Component {
//    constructor(props) {
//        super(props);
//    }

//    componentDidMount() {
//        this.createDataTable();
//    }
//    componentDidUpdate() {
//        this.createDataTable();
//    }

//    componentWillUnmount() {
//        this.destroyDataTable();
//    }

//    shouldComponentUpdate() {
//        this.destroyDataTable();
//        return true;
//    }

//    destroyDataTable() {
//        const elem = $('#' + this.props.tableref.id);
//        elem.DataTable().destroy(true);
//        $('#' + this.props.tableref.id + 'TableHolder').html('')
//    }

//    createDataTable() {
//        var cols = [];
//        var data = this.props.tableref.datatable;
//        if (data == null) {
//            data = [{ Error: "no datatable is present" }];
//        }

//        if (data.length == 0) {
//            data = [{ NoData: "no data was returned" }]
//        }

//        for (var c in data[0]) {
//            if (c != "idx" && c != "parsedStack") {
//                cols[cols.length] = { title: c }
//            }
//        }
//        var asStacks = this.props.view == 'Stacks';
//        var celldata = [];
//        for (var i = 0; i < data.length; i++) {
//            var row = data[i];
//            var rowcells = [];
//            for (var j = 0; j < cols.length; j++) {
//                var cellValue = row[cols[j].title];
//                if (cols[j].title == "Stack") {
//                    cellValue = '';

//                    if (asStacks) {
//                        for (var k = row.parsedStack.length - 1; k >= 0; k--) {
//                            var frame = row.parsedStack[k];
//                            cellValue += frame.module + '!' + frame.method + (k > 0 ? '<br/>' : '');
//                        }
//                    }
//                    else {
//                        var lastModule = -1;

//                        for (var k = 0; k < row.parsedStack.length; k++) {
//                            var frame = row.parsedStack[k];
//                            cellValue += (lastModule != -1 ? ' ' : '') + ' ' + (frame.moduleId != lastModule ? frame.module : '') + '!' + frame.method;
//                            lastModule = frame.moduleId;
//                        }
//                    }
//                }

//                rowcells[rowcells.length] = cellValue;
//            }
//            celldata[celldata.length] = rowcells;
//        }


//        $('#' + this.props.tableref.id + 'TableHolder').html('<table class="hover" id="' + this.props.tableref.id + '"/>')
//        const elem = $('#' + this.props.tableref.id);
//        elem.DataTable({
//            //new DataTable('#' + this.props.tableref.id, {
//            //dom: '<"data-table-wrapper"t>',
//            data: celldata,
//            "destroy": true,
//            "paging": false,
//            columns: cols,
//            bFilter: false,
//            bInfo: false,
//            "order": [],
//        });


//    }

//    render() {
//        return (
//            <div id={this.props.tableref.id + 'TableHolder'}>

//            </div>);
//    }
//}

class TimelineView extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        BuildTimeline(this.props.tableref);

        var threadIndices = [];
        for (var i = 0; i < this.props.tableref.timelineData.threads.length; i++) {
            threadIndices.push(i);
        }

        return (
            <div id="flamegraphdiv">
                <table><tbody><tr><td><div style={{ height: (4 + threadIndices.length * 8), position: 'relative', top: 1 }}>
                    {threadIndices.map((t) => <ThreadView threadIndex={t} timeline={this.props.tableref.timelineData} microsecondsPerPixel={this.props.microsecondsPerPixel} />)
                    }
                </div>
                </td></tr><tr><td>
                    <div data-theme={this.props.theme} style={{ height: (this.props.tableref.timelineData.maxLevel + 2) * 10, position: 'relative' }} id="flamegraph">
                        {this.props.tableref.timelineData.groups.filter((g) => (!this.props.hiddenthreads[g.threadId] && (g.type == 0 || !this.props.hidewaits))).map((g) => <TimelineGroup group={g} microsecondsPerPixel={this.props.microsecondsPerPixel} showMethodFirst={this.props.showMethodFirst} />)}
                    </div>
                </td></tr></tbody></table>
            </div>
        )
    }
}

class TimelineGroup extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        var group = this.props.group;
        var levels = [];
        //for (var i = group.topLevel; i >= -1; i--) {
        for (var i = -1; i <= group.topLevel; i++) {
            levels.push(i);
        }
        var bottom = group.type == 0 ? 0 : 3;
        var tableWidth = Math.max(group.duration / this.props.microsecondsPerPixel, 1);
        var columnWidth = 1.0 * tableWidth / group.indices.length;
        var dispensed = 0;
        var widths = [];
        for (var i = 0; i < group.indices.length; i++) {
            var end = Math.round((i + 1) * columnWidth);
            widths[i] = Math.max(1, end - dispensed);
            dispensed += widths[i];
        }

        return (
            <table className="flamegraph" style={{ position: 'absolute', left: group.start / this.props.microsecondsPerPixel, top: 'top', width: tableWidth, maxWidth: tableWidth }} data-threadid={group.threadId} data-grouptype={group.type}>
                <colgroup>
                    {widths.map((w) => <col style={{ maxWidth: w }} />)}
                </colgroup>
                <tbody>
                    {levels.map((l) => <TimelineGroupLevel key={l} level={l} group={group} microsecondsPerPixel={this.props.microsecondsPerPixel} colwidths={widths} showMethodFirst={this.props.showMethodFirst} />)}
                </tbody>
            </table>
        )

    }
}

class TimelineGroupLevel extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        var group = this.props.group;
        var level = this.props.level;
        var cols = [];
        for (var i = 0; i < group.indices.length; i++) {
            cols.push(i);
        }

        return (
            <tr>
                {cols.map((x) => GetFrame(group, level, x, this.props.microsecondsPerPixel, this.props.widths, this.props.showMethodFirst))}
            </tr>
        )
    }
}

class ThreadView extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        var timeline = this.props.timeline;
        var threadId = this.props.timeline.threads[this.props.threadIndex];
        var groups = [];
        for (var i = 0; i < timeline.groups.length; i++) {
            if (timeline.groups[i].threadId == threadId) {
                groups.push(timeline.groups[i]);
            }
        }

        return (
            <span>
                {
                    groups.map((group) => <div style={{ position: 'absolute', height: 4, left: group.start / this.props.microsecondsPerPixel, top: (4 * this.props.threadIndex + 4 * group.type), width: Math.max(group.duration / this.props.microsecondsPerPixel, 1), backgroundColor: (group.type == 0 ? 'rgb(255, 120, 20)' : 'rgb(30, 128, 255)') }} data-duration={group.duration} data-offset={group.start} title={'Thread ' + group.threadId}></div>)
                }
            </span>
        )
    }
}


class AggregatedStackView extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        BuildTimeline(this.props.tableref);

        var group = AggregateStacks(this.props.tableref.timelineData, this.props.hiddenthreads)
        return (

            <div style={{ position: 'relative' }} id="flamegraph">
                <TimelineGroup group={group} microsecondsPerPixel={this.props.microsecondsPerPixel} />)
            </div>
        )
    }
}

class CPUSummary extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        BuildTimeline(this.props.tableref);
        AggregateCPU(this.props.tableref.timelineData, this.props.hiddenthreads)

        var group = AggregateStacks(this.props.tableref.timelineData, this.props.hiddenthreads)
        return (
            <table>
                <thead>
                    <th>CPU ms</th>
                    <th>%</th>
                    <th>Method</th>
                </thead>
                <tbody>
                    {
                        this.props.tableref.timelineData.cpuSummary.map((f) => <tr><td>{f.cpu}</td><td>{f.cpuPercent}</td><td>{f.module}!{f.method}</td></tr>)
                    }
                </tbody>
            </table>
        )
    }
}

function BuildTimeline(tableref) {
    if (tableref.timelineData == null) {
        var timelineData = ExtractGroups(tableref.datatable);
        for (var group of timelineData.groups) {
            BuildGroupStacks(group, timelineData);
        }

        tableref.timelineData = timelineData;
        tableref.timelineData.stringTable = tableref.stringTable;
    }

    g_timelineData = tableref.timelineData;
}

function ExtractGroups(data) {
    var groups = [];
    var currentGroups = {};
    var offsets = []
    var durations = []
    for (var i = 0; i < data.length; i++) {
        // diaghub original code
        //offsets[i] = parseInt(data[i].TimeOffset);
        //if (data[i].Duration != '') {
        //    durations[i] = parseInt(data[i].Duration);
        //} else {
        //    durations[i] = 0;
        //}
        offsets[i] = data[i].TimelineOffset;
        if (data[i].Duration != null) {
            durations[i] = data[i].Duration;
        } else {
            durations[i] = 0;
        }
    }

    for (var i = 0; i < data.length; i++) {
        if (currentGroups[data[i].ThreadId] == null) {
            currentGroups[data[i].ThreadId] = [];
        }

        var currentGroup = currentGroups[data[i].ThreadId];
        // fix column name
        if (data[i].Type == 'OnCPU') {
            if (currentGroup.length > 0 && offsets[i] - offsets[currentGroup[currentGroup.length - 1]] > 1500) {
                groups.push({
                    type: 0,
                    threadId: data[i].ThreadId,
                    indices: currentGroup,
                    start: offsets[currentGroup[0]],
                    duration: offsets[currentGroup[currentGroup.length - 1]] - offsets[currentGroup[0]] + 1000,
                    groupIndex: groups.length,
                });
                currentGroups[data[i].ThreadId] = currentGroup = [];
            }
            currentGroup.push(i);
        }
    }

    var threads = [];
    for (var thread in currentGroups) {
        if (currentGroups[thread].length > 0) {
            groups.push({
                type: 0,
                threadId: thread,
                indices: currentGroups[thread],
                start: offsets[currentGroups[thread][0]],
                duration: offsets[currentGroups[thread][currentGroups[thread].length - 1]] - offsets[currentGroups[thread][0]] + 1000,
                groupIndex: groups.length,
            });
        }
        currentGroups[thread] = [];

        threads.push(thread);
    }

    currentGroup = []
    for (var i = 0; i < data.length; i++) {
        if (data[i].Type == 'OffCPU') {
            groups.push({
                type: 1,
                threadId: data[i].ThreadId,
                indices: [i],
                start: offsets[i],
                duration: durations[i]
            });

        }
    }

    return {
        data: data,
        offsets: offsets,
        durations: durations,
        groups: groups,
        maxLevel: 0,
        threads: threads,
    }
}


function BuildGroupStacks(group, timelineData) {
    var queue = [];
    group.rootStack = {
        level: -1,
        parent: null,
        indexInGroup: 0,
        length: group.indices.length,
        substacks: [],
    };

    group.topLevel = 0;


    queue.push(group.rootStack);

    for (var i = 0; i < queue.length; i++) {
        var stack = queue[i];
        var runningStack = null;

        var currentFrame = null;
        for (var j = 0; j < stack.length; j++) {
            var parsed = timelineData.data[group.indices[j + stack.indexInGroup]].parsedStack;

            var closePrevious = false;

            if (parsed.length <= stack.level + 1) {
                closePrevious = true;
            } else {
                if (runningStack == null) {
                    closePrevious = true;
                } else {
                    var frame = parsed[stack.level + 1];

                    if (runningStack.frame.hash != frame.hash) {
                        closePrevious = true;
                    }
                }
            }

            if (closePrevious) {
                if (runningStack != null) {
                    runningStack.length = j + stack.indexInGroup - runningStack.indexInGroup;
                    //stack.substacks.push(runningStack);
                    runningStack = null;
                }

                if (parsed.length > stack.level + 1) {
                    runningStack = {
                        level: stack.level + 1,
                        parent: stack,
                        indexInGroup: stack.indexInGroup + j,
                        length: 0,
                        substacks: [],
                        frame: parsed[stack.level + 1],
                    }

                    if (runningStack.level > group.topLevel) {
                        group.topLevel = runningStack.level;
                    }

                    stack.substacks.push(runningStack);
                    queue.push(runningStack);
                }
            }

        }

        if (runningStack != null) {
            runningStack.length = stack.length + stack.indexInGroup - runningStack.indexInGroup;
        }

        if (group.topLevel > timelineData.maxLevel) {
            timelineData.maxLevel = group.topLevel
        }
    }
}


function AggregateStacks(timelineData, hiddenThreads) {
    var rootStack = {
        level: -1,
        parent: null,
        indexInGroup: 0,
        length: 0,
        substacks: [],
    };

    var topLevel = -1;
    for (var stack of timelineData.data) {
        if (stack.Type == 'OffCPU') continue;
        if (hiddenThreads[stack.ThreadId]) continue;

        var parent = rootStack;
        for (var frame of stack.parsedStack) {
            var targetStack = parent.substacks.find(e => e.frame.hash == frame.hash);
            if (targetStack == null) {
                targetStack = {
                    level: parent.level + 1,
                    parent: parent,
                    indexInGroup: 0,
                    length: 0,
                    substacks: [],
                    frame: { hash: frame.hash, module: frame.module, method: frame.method, moduleId: frame.moduleId }
                }
                parent.substacks.push(targetStack);
            }

            if (targetStack.level > topLevel) topLevel = targetStack.level;

            parent.length++;
            parent = targetStack;
        }
        parent.length++;
    }

    var queue = [];

    queue.push(rootStack);

    for (var i = 0; i < queue.length; i++) {
        var stack = queue[i];
        stack.substacks.sort((a, b) => b.length - a.length);

        var indexInGroup = stack.indexInGroup;
        for (var substack of stack.substacks) {
            substack.indexInGroup = indexInGroup;
            indexInGroup += substack.length;
            queue.push(substack);
        }
    }

    var indices = [];
    for (var i = 0; i < rootStack.length; i++) indices.push(i);

    return {
        type: 0,
        start: 0,
        rootStack: rootStack,
        topLevel: topLevel,
        indices: indices,
        duration: ((rootStack.length + 1) * 1000),
    }
}

function AggregateCPU(timelineData, hiddenThreads) {
    debugger;
    var tally = {};
    var cpuCount = 0;
    for (var stack of timelineData.data) {
        if (stack.Type == 'OffCPU') continue;
        if (hiddenThreads[stack.ThreadId]) continue;

        for (var i = 0; i < stack.parsedStack.length; i++) {
            var frame = stack.parsedStack[i];
            var found = false;

            for (var j = 0; j < i; j++) {
                if (stack.parsedStack[j].hash == frame.hash) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                if (!tally[frame.hash]) {
                    tally[frame.hash] = 1;
                } else {
                    tally[frame.hash] += 1;
                }
            }
        }

        cpuCount++;
    }

    var asArray = [];
    for (var f in tally) {
        const frameHash = Number(f);
        asArray.push(
            {
                hash: frameHash,
                cpu: tally[f],
                cpuPercent: (~~(10000 * tally[f] / cpuCount)) / 100,
                module: timelineData.stringTable[~~(frameHash / 65000)],
                method: timelineData.stringTable[frameHash % 65000]
            });
    }

    asArray.sort((a, b) => b.cpu - a.cpu);

    timelineData.cpuSummary = asArray;
}

// Extract logic from GetFrame into GetFrameData (returns data, not JSX)
function GetFrameData(group, level, column, microsecondsPerPixel, widths, showMethodFirst) {
    var stack = group.rootStack;
    var cellClass = group.type == 0 ? "frame oncpu" : "frame offcpu";
    var tablewidth = Math.max(group.duration / microsecondsPerPixel, 1);

    if (level == -1) {
        if (column > 0) {
            return null;
        }
        var text = '' + (group.type == 0 ? group.indices.length : (1.0 * group.duration / 1000)) + ' ms ' + (group.type == 0 ? 'cpu' : 'wait') + ' at ' + (1.0 * group.start / 1000) + ' ms';
        return {
            stack,
            cellClass,
            text,
            colSpan: stack.length,
            tablewidth: group.type == 0 ? null : tablewidth
        };
    }

    while (stack != null && stack.level < level) {
        var nextStack = null;
        for (var sub of stack.substacks) {
            if (sub.indexInGroup <= column && column < sub.indexInGroup + sub.length) {
                nextStack = sub;
                break;
            }
        }
        stack = nextStack;
    }

    if (stack == null) {
        return null;
    }
    else if (column == stack.indexInGroup) {
        // Format the frame name using formatNodeName
        var fullName = stack.frame.module + '!' + stack.frame.method;
        var formattedName = formatNodeName(fullName, showMethodFirst || false);
        var text = formattedName + ' (' + (group.type == 0 ? stack.length : (1.0 * group.duration / 1000)) + ' ms)';

        // Calculate pixel width for this frame
        var frameWidth = stack.length * (1000 / microsecondsPerPixel);

        // Add width-based class for better text rendering
        var widthClass = '';
        if (frameWidth < 50) {
            widthClass = ' narrow';
        } else if (frameWidth < 150) {
            widthClass = ' medium';
        } else {
            widthClass = ' wide';
        }

        cellClass += widthClass;

        return {
            stack,
            cellClass,
            text,
            colSpan: stack.length,
            tablewidth: group.type == 0 ? frameWidth : tablewidth
        };
    } else {
        return null;
    }
}

// Create wrapper component for GetFrame to use hooks
function FrameCell({ group, level, column, microsecondsPerPixel, widths, showMethodFirst }) {
    const { handleFrameHover, handleFrameLeave, handleFrameClick } = useTimeline();

    const frameData = GetFrameData(group, level, column, microsecondsPerPixel, widths, showMethodFirst);

    if (!frameData) return null;

    const { stack, cellClass, text, colSpan, tablewidth } = frameData;

    const handleMouseEnter = (e) => {
        if (stack) {
            handleFrameHover({ stack, group }, e);
        }
    };

    const handleClick = (e) => {
        if (stack) {
            handleFrameClick({ stack, group }, e);
        }
    };

    return (
        <td
            className={cellClass}
            colSpan={colSpan}
            title={text}
            style={tablewidth ? { maxWidth: tablewidth } : {}}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleFrameLeave}
            onClick={handleClick}
        >
            {text}
        </td>
    );
}

// Update GetFrame to use FrameCell
function GetFrame(group, level, column, microsecondsPerPixel, widths, showMethodFirst) {
    return <FrameCell
        group={group}
        level={level}
        column={column}
        microsecondsPerPixel={microsecondsPerPixel}
        widths={widths}
        showMethodFirst={showMethodFirst}
    />;
}
